import { render, staticRenderFns } from "./dataCollector.vue?vue&type=template&id=9434f6e2&scoped=true&"
import script from "./dataCollector.vue?vue&type=script&lang=js&"
export * from "./dataCollector.vue?vue&type=script&lang=js&"
import style0 from "./dataCollector.vue?vue&type=style&index=0&id=9434f6e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9434f6e2",
  null
  
)

export default component.exports